<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <!-- <div class="header">
      <div>
        <h2 class="title">
          <div> -->
            <!-- <span *ngIf="baseFormGroup.get('ID').value<=0"  translate="DOCUMENT.NEW"></span> -->
            <!-- <span *ngIf="baseFormGroup.get('ID').value<=0">Novi dokument</span>
            <span *ngIf="baseFormGroup.dirty" style="color:steelblue">*</span>
            <span *ngIf="editMode" class="fa fa-fw fa-pencil item-icon"></span>
          </div>
        </h2>
      </div>
    </div> -->

    <!-- <div> -->
    <div class="row">
      <div class="col-md-7">
      <div class="row">

        <!-- Podvrsta dokumenta -->
        <div class="col-xl-5 col-md-6">
          <div class="form-group row">
            <!-- <label for="cmbPodVrstaDokumenta" class="col-form-label col-md-3">
              <span translate="DOCUMENT.SUBTYPE.SINGULAR"></span>
            </label> -->
            <div class="col-md-12">
              <!-- <yt-fw-dropdown
                [ModelName]="'podvrstadokumentastavka'" 
                [GetName]="'GetByUrl'"
                [ModelProperty]="'Sifra,Naziv'" 
                [GetParameters] = "modelData.MainList.GetParameters"
                formControlName="PodVrstaDokumentaStavkaID" 
                #focusElement
                [Type]="ID"
                [Label]="'DOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                #autofocus
                [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}">
              </yt-fw-dropdown> -->
              <yt-dropdown-picklist
                [ModelName]="'podvrstadokumentastavka'"
                [GetName]="'GetByUrl'"
                [ModelProperty]="'Sifra,Naziv'"
                [GetParameters]="modelData.MainList.GetParameters"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="PodVrstaDokumentaStavkaID"
                [Label]="'DOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
              >
              </yt-dropdown-picklist>  
              <!-- <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaID.invalid">
                <span *ngFor="let validation of errorMessages.PodVrstaDokumentaID">
                  <span class="error-message" *ngIf="fc.PodVrstaDokumentaID.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div> -->
            </div>
          </div>
        </div>
        
        <!-- BrojDokumenta -->
        <div class="col-xl-7 col-md-6"> 
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <!-- <div class="col-md-6">
                  <b> -->
                    <!-- <label for="txtBrojDokumenta" class="col-form-label col-xl-3 col-md-6">
                      <span translate="DOCUMENT.NUMBER.SINGULAR"></span>
                    </label> -->
                  <!-- </b>
                </div> -->
                <div class="col-md-12">
                  <!-- <div class="form-group row">
                    <div class="col-md-5"> -->
                    <!-- !!<div class="input-group"> -->
                      <!-- <input
                        type="number" 
                        id="txtBrojDokumenta" 
                        name="txtBrojDokumenta" 
                        formControlName="BrojDokumenta"
                        class="form-control text-right"
                        autocomplete="off"
                        placeholder="{{ 'DOKUMENT.BROJDOKUMENTA.SINGULAR' | translate}}"
                      > -->
                    <!-- </div> -->
                    <!-- !!<div class="input-group-addon"> -->
                    <!-- <div class="col-md-2 padding-left-0"> -->
                      <!-- <b> -->
                        <!-- !!<span class="span-control">/</span> -->
                      <!-- </b> -->
                    <!-- </div> -->
                    <!-- <div class="col-md-5"> -->
                      <!-- <b> -->
                        <!-- !!<span *ngIf="baseFormGroup.get('Datum').value!=null" class="span-control">{{baseFormGroup.get("Datum").value.year}}</span> -->
                      <!-- </b> -->
                    <!-- </div> -->
                  <!-- !!</div> -->
                  <!-- !!</div> -->
                  <!-- </div> -->
                  <div class="input-group">
                    <yt-input
                        [Type]="'text'"
                        [Label]="'DOKUMENT.BROJDOKUMENTA.SINGULAR'"
                        formControlName="BrojDokumenta"
                        [ngClass]="{'is-invalid': submitted && fc.BrojDokumenta.invalid}">
                    </yt-input>
                    <div class="input-group-append">
                      <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                    </div>
                  </div>
                </div>
              </div>  
            </div>

        <!-- Datumdokumenta -->
          <div class="col-md-6">
            <div class="form-group row">
              <!-- <div class="col-md-6"> -->
                  <!-- <label for="txtRokPlacanja" class="control-label col-md-3"><span translate="DOCUMENT.DATE.PAYMENT">Rok plaćanja</span></label> -->
              <!-- <label for="txtDatum" class="col-form-label col-xl-3 col-md-6"><span translate="DOCUMENT.DATE.SINGULAR"></span></label> -->
              <!-- </div>   -->
              <div class="col-md-12">
                <yt-fw-date-picker-popup
                    formControlName="Datum"
                    name="txtDatum" 
                    [Label]="'DOKUMENT.DATUM.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}">
                </yt-fw-date-picker-popup>
              </div>  
            </div>  
          </div>  
        </div>  
      </div>  
    </div>
  


      <!-- <div class="row">
        <div class="col-md-4" *ngIf="isVisible('txtProdajnaCena')">
        
            <div class="form-group row">
            <label for="txtRokPlacanja" class="control-label col-md-3"><span translate="DOCUMENT.DATE.PAYMENT">Rok plaćanja</span></label>
            <div class="col-md-9">
              <yt-fw-date-picker-popup
                formControlName="RokPlacanja"
                name="txtRokPlacanja" 
              >
              </yt-fw-date-picker-popup>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="row" *ngIf="isVisible('txtProdajnaCena')">
        <div class="col-md-4">
          <div class="form-group row">
            <label for="txtBrojOtpremnice" class="control-label col-md-4">Broj otpremnice:</label>
            <div class="col-md-8">
              <input type="text" id="txtBrojOtpremnice" name="txtBrojOtpremnice" class="form-control" #focusInput>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group row">
            <label for="txtDatumOtpremnice" class="control-label col-md-4">Datum otpremnice:</label>
            <div class="col-md-8">
              <yt-fw-date-picker-popup
                name="txtDatumOtpremnice" 
                formControlName="DatumOtpremnice"
              >
              </yt-fw-date-picker-popup>
            </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-xl-5 col-md-6">
          <div class="form-group row">
            <!-- <label for="cmbKomitent" name="cmbKomitent" class="col-form-label col-md-3">
              <span translate="CUSTOMER.SINGULAR"></span>
            </label> -->
            <div class="col-md-12">
              <!-- <yt-fw-dropdown
                [ModelName]="'komitent'" 
                [GetName]="'get'" 
                [ModelProperty]="'SNaziv,Mesto'"
                formControlName="KomitentID" 
                [AllowAddNew]="true"
                [Type]="ID"
                [Label]="'DOKUMENT.KOMITENT.SINGULAR'"
              >
              </yt-fw-dropdown> -->

              <yt-dropdown-picklist
                [ModelName]="'komitent'"
                [GetName]="'get'"
                [ModelProperty]="'SNaziv,Mesto'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="true"
                formControlName="KomitentID"
                [Label]="'DOKUMENT.KOMITENT.SINGULAR'"
              >
              
              </yt-dropdown-picklist>
            </div>
          </div>
        </div>

        <div class="col-xl-7 col-md-6">
           <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <!-- <div class="col-md-6"> -->
                  <!-- <label for="txtBrojDokumentaKomitenta" name="txtBrojDokumentaKomitenta" class="col-form-label col-md-6"> -->
                    <!-- <span translate="DOCUMENT.NUMBER.SHORT"> -->
                    <!-- <span>Broj dokumenta dob.</span>
                  </label> -->
                <!-- </div> -->
                <div class="col-md-12">
                  <!-- <input 
                    type="text" 
                    id="txtBrojDokumentaKomitenta" 
                    name="txtBrojDokumentaKomitenta" 
                    class="form-control"
                    formControlName="BrojDokumentaKomitenta"
                    placeholder="{{ 'DOKUMENT.BROJDOKUMENTAKOMITENTA.SINGULAR' | translate }}"> -->
                    <yt-input
                      [Type]="'text'"
                      [Label]="'DOKUMENT.BROJDOKUMENTAKOMITENTA.SINGULAR'"
                      formControlName="BrojDokumentaKomitenta"></yt-input>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <!-- <div class="col-md-6"> -->
                  <!-- <label for="txtDatumdokumentaKomitenta" class="col-form-label col-md-6">
                    <span translate="DOCUMENT.DATE.SHORT">Datum dokumenta dob.</span>
                  </label> -->
                <!-- </div> -->
                <div class="col-md-12">
                  <yt-fw-date-picker-popup
                    name="txtDatumdokumentaKomitenta" 
                    formControlName="DatumDokumentaKomitenta"
                    [Label]="'DOKUMENT.DATUM.SINGULAR'">
                  </yt-fw-date-picker-popup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5">
      <!-- <div class="row margin-top-05"> -->
      <!-- <div> -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <!-- <label for="txtNapomena" class="control-label col-md-2"><span translate="NOTE.SINGULAR">Napomena</span></label> -->
              <!-- <label for="txtNapomena" class="colform-label col-md-3"><span>Napomena</span></label> -->
              <div class="col-md-12">
                <!-- <textarea 
                    type="text" 
                    id="txtNapomena" 
                    name="txtNapomena" 
                    class="form-control input" 
                    formControlName="Napomena"
                    style="resize:none"
                    placeholder="{{ 'DOKUMENT.NAPOEMNA.SINGULAR' | translate }}"></textarea> -->
                  <yt-text-area
                    [MaxLength]="500"
                    name="txtNapomena"
                    formControlName="Napomena"
                    [Label]="'DOKUMENT.NAPOMENA.SINGULAR'">
                  </yt-text-area>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6">
            <button
              type="button" 
              class="btn btn-primary float-right" 
              (click)="SaveMaster(true)" 
              [disabled]="!baseFormGroup.get('KomitentID').valid
                || !baseFormGroup.get('Datum').valid
                || !baseFormGroup.get('BrojDokumenta').valid
                || !baseFormGroup.get('PodVrstaDokumentaID').valid
              "
            > -->
              <!-- <span translate="SAVEMASTER.ACTION"></span> -->
              <!-- <span>Sačuvaj zaglavlje</span>
            </button>
          </div> -->
        </div>
    </div>
  </div>
      <!-- </div> -->
    <!-- </div> -->
    <!-- <yt-dokument-stavka-update></yt-dokument-stavka-update> -->
    <!-- <yt-fw-default-list-tabs [CondensedTable]="true"></yt-fw-default-list-tabs> -->
    <!-- <yt-fw-default-detail-list [Model]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'DokumentID'" [ParentPropertyValue]="Item.ID" [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list> -->
    <div class="row">
      <div class="col-md-12">
        <yt-dokument-stavka-update-container 
        #baseInlineContainer
        [DetailModelData]="modelData.MainList.DetailList[0]" 
        [ParentPropertyName]="'DokumentID'" 
        [ParentPropertyValue]="Item.ID"></yt-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>

